var ScriptLoader = (function () {
  // var loadedUrls = [];
  var loadedUrls2 = [];

  function load(urls, callback) {
      if (typeof urls === "string") {
          urls = [urls];
      }

      // if(!urls || typeof urls !== "array") {
      //     return;
      // }

      var url = urls.shift();

      var _callback;
      if (urls.length === 0) {
          _callback = callback;
      } else {
          _callback = function () {
              load(urls, callback);
          }
      }

      _load(url, _callback);
  }

  function _isLoaded(url) {
      // return loadedUrls[url] === true;
      return loadedUrls2[url] !== undefined && loadedUrls2[url].loaded === true;
  }

  function _load(url, callback) {
      if (_isLoaded(url)) {
        //   _log("이미 로드된 스크립트입니다. url: " + url);
          if (callback) callback();
          return;
      }

      // loadedUrls[url] = false;

      var scriptEl = document.createElement('script');
      scriptEl.type = 'text/javascript';
      scriptEl.src = url;

      var isAppended = false;
      var scripts = document.getElementsByTagName("script");
      for(var i = 0; i < scripts.length; i++) { // 새로 삽입하려는 스크립트가 이미 불렸는지 체크
          if(scripts[i].src === scriptEl.src) {
              isAppended = true;

              if(loadedUrls2[url]) { // ScriptLoader에 의해 이미 삽입되었거나 이미 검사한 script 태그인 경우
                  if(loadedUrls2[url].loaded === true) { // 이미 삽입되어 load 이벤트까지 발생한 시점은 바로 콜백 실행
                      if(callback) callback();
                  } else { // 삽입은 되었지만 아직 다 로드되지 못한 상태라면 기존의 콜백을 먼저 실행하고 새로운 콜백을 실행
                      var oldCallback = scripts[i].onload;
                      scripts[i].onload = function () {
                          oldCallback(); // 바로 break 구문을 만나므로 for문을 계속 돌지 못하므로 mutable일 수 없음. mutable 경고는 무시
                          if (callback) callback();
                      };
                  }
              } else { // 불러들이려는 스크립트가 이미 삽입되었지만 ScriptLoader에 의한 것이 아닌 경우(script 태그로 직접 삽입한 경우)
                  loadedUrls2[url] = {appended: true, loaded: true}; // script 태그로 직접 삽입된 경우는 asnyc 속성이 붙지 않는 한 동기식으로 작동
                  if(scripts[i].onload) scripts[i].onload();
                  if(callback) callback();
              }

              break;

              // if (loadedUrls[url] === true) { // 이미 삽입되어 load 이벤트까지 발생한 시점은 바로 콜백 실행
              //     _log("111111");
              //     if (callback) callback();
              // } else { // 삽입은 되었지만 아직 다 로드되지 못한 상태라면 기존의 콜백을 먼저 실행하고 새로운 콜백을 실행
              //     _log("222222" + scriptEl.src);
              //     _log(scripts[i].onload);
              //
              //     var oldCallback = scripts[i].onload;
              //     scripts[i].onload = function () {
              //         _log("3333");
              //         oldCallback(); // 바로 break 구문을 만나므로 for문을 계속 돌지 못하므로 mutable일 수 없음. mutable 경고는 무시
              //         if (callback) callback();
              //     };
              //     break;
              // }
          }
      }

      if(!isAppended) { // 아직 삽입되지 않은 경우에만 삽입
          // IE에서는 onreadystatechange를 사용
          scriptEl.onload = function () {
              // loadedUrls[url] = true;
              loadedUrls2[url].loaded = true;
              if(callback) callback();
          };
          document.getElementsByTagName('head')[0].appendChild(scriptEl);
          loadedUrls2[url] = {appended: true, loaded: false};
      }
  }

  function _log(message) {
      try {
          console.log(message);
      } catch (e) {
          //
      }
  }

  return {
      load: load
  };
}());

export default ScriptLoader
